import { createRouter, createWebHistory } from 'vue-router';
import Main from '@/views/Main.vue';
import NotFound from '@/views/NotFound.vue';

const routes = [
  {
    path: `${process.env.VUE_APP_API_ROOT}/`,
    name: 'Main',
    component: Main,
  },
  {
    path: `${process.env.VUE_APP_API_ROOT}/:pathMatch(.*)*`,
    name: 'NotFound',
    component: NotFound,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.VUE_APP_API_ROOT),
  routes,
});

export default router;
